import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FILTER_CONTENT_ITEM, ISelectInput, SearchSelector } from '@portal/shared/ui/filter';
import { FilterStaticBase } from '@portal/shared/ui/filter/src/lib/components/static-base';
import { TransactionFilterList } from '../transaction-filters.list';
import { HeaderStates } from './header-state.list';
import { FiltersService } from '@portal/shared/ui/filter/src/lib/services/filters.service';
import { TransactionFilter } from '../../../enums/transaction-filter.enum';
import cloneDeep from 'lodash/cloneDeep';
import { SupportedProcessorSettingsService } from '@apps/portal/src/app/services/supported-processor-settings.service';

@Component({
  selector: 'portal-filter-header-state',
  templateUrl: './header-state.component.html',
  providers: [
    {
      provide: FILTER_CONTENT_ITEM,
      useExisting: FilterHeaderStateComponent,
    },
  ],
  standalone: false,
})
export class FilterHeaderStateComponent extends FilterStaticBase {
  @Input()
  isMainDropdownFilter: boolean;
  @Input()
  showFilterSubMenu: boolean;
  @Output() headerStateTextName: EventEmitter<string> = new EventEmitter();
  transactionStateText = this.transactionfilters.list.find(
    (filter) => filter.id === TransactionFilter.TransactionState,
  ).text;
  transactionStates: ISelectInput[];

  constructor(
    private headerStates: HeaderStates,
    private transactionfilters: TransactionFilterList,
    private filtersService: FiltersService,
    private supportedProcessorSettingsService: SupportedProcessorSettingsService,
  ) {
    super(
      SearchSelector.DisplayTransactionState,
      headerStates.supportedTransactionStateFromProcessorSettings(),
    );
    this.transactionStates = cloneDeep(headerStates.list);
    this.supportedProcessorSettingsService.isProcessorFetched$.subscribe(() => {
      this.setAllEntities(headerStates.supportedTransactionStateFromProcessorSettings());
    });
    this.filtersService.actionRemoveFilter$.subscribe((entityToRemove: ISelectInput) => {
      if (TransactionFilter.TransactionState === entityToRemove.key) {
        const selectedEntity = this.localPreSelectedEntities.get(entityToRemove.id);
        if (selectedEntity?.id) {
          this.onEntityRemoved(entityToRemove);
          this.onFilterApplied();
          this.itemToggled.emit();
        }
      }
    });

    this.subMenuComponentSelected$.subscribe((submenu) => {
      if (SearchSelector.DisplayTransactionState.includes(submenu)) {
        this.synchronizeLocalPreSelectedEntities();
      }
      this.updateEntities();
    });

    this.updateEntities$.subscribe(() => {
      if (this.isMainDropdownFilter) {
        this.synchronizeLocalPreSelectedEntities();
      }
      this.updateEntities();
    });

    this.updateCounter$.subscribe(() => {
      const localPreSelected: Map<string, ISelectInput> = new Map();
      if (this.criteriaMapPreSelected.has(SearchSelector.DisplayTransactionState)) {
        const argumentArr = this.getArgumentArray(
          this.criteriaMapPreSelected,
          SearchSelector.DisplayTransactionState,
        );

        if (this.criteriaMapPreSelected.get(SearchSelector.DisplayTransactionState)?.argument) {
          argumentArr?.forEach((argument) => {
            localPreSelected.set(argument, {
              id: argument,
              text: this.headerStates.getValue(argument),
            });
          });
          this.localPreSelectedEntities = cloneDeep(localPreSelected);
        } else {
          this.localPreSelectedEntities.clear();
        }
      }
      this.updateEntities();
    });
  }

  onFilterAppliedAndEntitiesUpdated(): void {
    this.onFilterApplied();
    this.updateEntities();
    if (this.isOpen) {
      this.closeSubmenus$.next(true);
    }
    this.headerStateTextName.emit(this.transactionStateText);
    this.isOpen = false;
  }

  private synchronizeLocalPreSelectedEntities(): void {
    if (this.criteriaMapPreSelected?.get(SearchSelector.DisplayTransactionState)?.argument) {
      const argumentArr = this.getArgumentArray(
        this.selectedEntities,
        SearchSelector.DisplayTransactionState,
      );

      this.localPreSelectedEntities.clear();
      argumentArr?.forEach((argument) => {
        this.setLocalPreSelectedEntities(argument, this.headerStates.getValue(argument));
      });
    } else {
      this.localPreSelectedEntities.clear();
    }
    this.updateEntities();
  }
}
